export default "__VITE_ASSET__DyizlSuZ__"